<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSubscriptionStore } from '@/Store/SubscriptionStore.js'

const router = useRouter()
const subscriptionStore = useSubscriptionStore()

onMounted(async () => {
    await subscriptionStore.fetchSubscription()
    await subscriptionStore.fetchAccessibleModules()
})

const goToDashboard = () => {
    router.push({ name: 'dashboard' })
}

const goToManage = () => {
    router.push({ name: 'subscription.manage' })
}
</script>

<template>
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-5">
                <!-- Header -->
                <div class="text-center mb-4">
                    <i class="ri-checkbox-circle-fill fs-success-icon text-success mb-3 d-block"></i>
                    <h4 class="fw-semibold fs-24">Abonnement activé</h4>
                    <p class="text-muted fs-15">
                        Votre paiement a été confirmé avec succès
                    </p>
                </div>

                <!-- Success Card -->
                <div class="card success-card">
                    <div class="card-body p-4 text-center">
                        <div class="mb-4">
                            <div class="success-checkmark mb-3">
                                <i class="ri-check-line"></i>
                            </div>
                            <p class="text-muted mb-0">
                                Vous avez maintenant accès à toutes les fonctionnalités de votre plan.
                            </p>
                        </div>

                        <hr class="my-4 opacity-25">

                        <div class="d-grid gap-2">
                            <button class="btn btn-success" @click="goToDashboard">
                                <i class="ri-dashboard-line me-2"></i>
                                Aller au tableau de bord
                            </button>
                            <button class="btn btn-outline-dark" @click="goToManage">
                                <i class="ri-settings-3-line me-2"></i>
                                Gérer mon abonnement
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Security Notice -->
                <div class="text-center mt-4">
                    <div class="d-flex align-items-center justify-content-center gap-2 text-muted small">
                        <i class="ri-shield-check-line"></i>
                        <span>Paiement sécurisé par Stripe</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.success-card {
    border: 1px solid #5CB85C;
    border-radius: 9px;
    box-shadow: 0 2px 8px rgba(92, 184, 92, 0.1);
}

.success-checkmark {
    width: 64px;
    height: 64px;
    background-color: rgba(92, 184, 92, 0.1);
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.success-checkmark i {
    font-size: 2rem;
    color: #5CB85C;
}

.fs-success-icon {
    font-size: 3rem;
}

.fs-24 {
    font-size: 1.5rem;
}

.fs-15 {
    font-size: 0.9375rem;
}
</style>
